import { useStateSelector } from '../store/selectors';

export const useServiceFocuses = () => {
    return useStateSelector((s) => s.serviceFocusesState.serviceFocuses);
};
